import {
  EMessagesActionTypes,
  TSetAsReadPayload,
  TMessagesErrorPayload,
  TMessageListPayload,
  TMessagesV2ListPayload,
} from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Пометить сообщения как прочитанные
 */
export const setMessagesAsRead = actionGenerator<EMessagesActionTypes.SetAsRead, TSetAsReadPayload>(
  EMessagesActionTypes.SetAsRead,
);

/**
 * Состояние загрузки сообщений
 */
export const setMessagesPending = actionGenerator<EMessagesActionTypes.SetMessagesPending, { chatId: string }>(
  EMessagesActionTypes.SetMessagesPending,
);

/**
 * Успешная загрузка сообщений
 */
export const setMessagesFulfilled = actionGenerator<EMessagesActionTypes.SetMessagesFulfilled, TMessageListPayload>(
  EMessagesActionTypes.SetMessagesFulfilled,
);

/**
 * Ошибка загрузки сообщений
 */
export const setMessagesFailed = actionGenerator<EMessagesActionTypes.SetMessagesFailed, TMessagesErrorPayload>(
  EMessagesActionTypes.SetMessagesFailed,
);

/**
 * Состояние синхронизации сообщений
 */
export const setSynchronizationMessagesPending = actionGenerator<
  EMessagesActionTypes.SetSynchronizationMessagesPending,
  { chatId: string }
>(EMessagesActionTypes.SetSynchronizationMessagesPending);

/**
 * Успешная синхронизация сообщений
 */
export const setSynchronizationMessagesFulfilled = actionGenerator<
  EMessagesActionTypes.SetSynchronizationMessagesFulfilled,
  TMessagesV2ListPayload
>(EMessagesActionTypes.SetSynchronizationMessagesFulfilled);
